import { api, getAuthHeader } from './help';

export const getBuilding = async (data) => {
  const { id, role, ...detail } = data;
  let response;
  if (role !== 'll') {
    response = await api.post('/user/get/properties', { data: id, ...detail }, getAuthHeader());
  } else {
    response = await api.post(
      '/user/get/properties',
      { landlordId: id, ...detail },
      getAuthHeader(),
    );
  }
  return response.data;
};

export const getUserApp = async (data) => {
  const { id, role, ...details } = data;
  let response;
  if (role !== 'll') {
    response = await api.post(
      '/user/applications',
      {
        buildingId: id,
        ...details,
      },
      getAuthHeader(),
    );
  } else {
    response = await api.post(
      '/user/applications',
      {
        landlordId: id,
        ...details,
      },
      getAuthHeader(),
    );
  }
  return response.data;
};

export const getUserPolicy = async (data) => {
  const { id, role, ...details } = data;
  let response;
  if (role !== 'll') {
    response = await api.post(
      '/user/policies',
      {
        buildingId: id,
        ...details,
      },
      getAuthHeader(),
    );
  } else {
    response = await api.post(
      '/user/policies',
      {
        landlordId: id,
        ...details,
      },
      getAuthHeader(),
    );
  }
  return response.data;
};

export const getUserClaim = async (data) => {
  const { id, role, ...details } = data;
  let response;
  if (role !== 'll') {
    response = await api.post(
      '/user/claims',
      {
        buildingId: id,
        ...details,
      },
      getAuthHeader(),
    );
  } else {
    response = await api.post(
      '/user/claims',
      {
        landlordId: id,
        ...details,
      },
      getAuthHeader(),
    );
  }
  return response.data;
};

export const getInviteLandlord = async (payload = {}) => {
  const { type, filter, sortOptions, ...rest } = payload;
  const response = await api.get('/user/invite-landlords', {
    ...getAuthHeader(),
    params: {
      type,
      ...rest,
      filter: JSON.stringify(filter || {}),
      sortOptions: JSON.stringify(sortOptions || {}),
    },
  });
  return response.data;
};

export const getActiveLandlord = async (data = {}) => {
  const { filter, sortOptions, ...rest } = data;
  const response = await api.get('/user/active-landlords', {
    ...getAuthHeader(),
    params: {
      ...rest,
      filter: JSON.stringify(filter || {}),
      sortOptions: JSON.stringify(sortOptions || {}),
    },
  });
  return response.data;
};

export const getLandlordDetail = async (payload) => {
  const landlordId = typeof payload === 'object' && payload !== null ? payload.landlordId : payload;
  const includeInactive =
    typeof payload === 'object' && payload !== null ? payload.includeInactive : false;
  const response = await api.get(`/user/landlord/detail/${landlordId}`, {
    ...getAuthHeader(),
    params: includeInactive ? { includeInactive: true } : undefined,
  });
  return response.data;
};

export const getDelegationDetail = async (delegationId) => {
  const response = await api.get(`/user/delegation/detail/${delegationId}`, getAuthHeader());
  return response.data;
};

export const getVP = async (data = {}) => {
  const { filter, sortOptions, ...rest } = data;
  const response = await api.get('/user/propertymanager/vp', {
    ...getAuthHeader(),
    params: {
      ...rest,
      filter: JSON.stringify(filter || {}),
      sortOptions: JSON.stringify(sortOptions || {}),
    },
  });
  return response.data;
};

export const getRM = async (data = {}) => {
  const { filter, sortOptions, ...rest } = data;
  const response = await api.get('/user/propertymanager/rm', {
    ...getAuthHeader(),
    params: {
      ...rest,
      filter: JSON.stringify(filter || {}),
      sortOptions: JSON.stringify(sortOptions || {}),
    },
  });
  return response.data;
};

export const getPM = async (data = {}) => {
  const { filter, sortOptions, ...rest } = data;
  const response = await api.get('/user/propertymanager/pm', {
    ...getAuthHeader(),
    params: {
      ...rest,
      filter: JSON.stringify(filter || {}),
      sortOptions: JSON.stringify(sortOptions || {}),
    },
  });
  return response.data;
};

export const delUsers = async (data) => {
  const response = await api.post('/user/delete-user', data, getAuthHeader());
  return response.data;
};

export const updateProperty = async (data) => {
  const response = await api.put('/notification/update-property', data, getAuthHeader());
  return response.data;
};

export const deleteLandlord = async (data) => {
  const response = await api.delete('/user/landlord?id=' + data, getAuthHeader());
  return response.data;
};

export const getLandlordTree = async () => {
  const response = await api.get('/user/landlordtree', getAuthHeader());
  return response.data;
};

export const getVPTree = async () => {
  const response = await api.get('/user/vptree', getAuthHeader());
  return response.data;
};

export const getRMTree = async () => {
  const response = await api.get('/user/rmtree', getAuthHeader());
  return response.data;
};

export const getUserBuildingSearch = async (data) => {
  const response = await api.post('/user/user-property-search', data, getAuthHeader());
  return response.data;
};

export const setDelegationMoveOut = async (data) => {
  const response = await api.post('/user/delegationmoveout', data, getAuthHeader());
  return response.data;
};

export const getUserList = async (data) => {
  const response = await api.post('/user/getuserlist', data, getAuthHeader());
  return response.data;
};
